import React, { Component } from 'react'
import ReactTable from "react-table-6"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

export default class AdvanceSettings extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            contentEditable: "false",
            editId: "-1",
            switchDisable: false,
            index: "",
        };
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    }

    componentDidMount() {
        var settingController = this;

        setTimeout(() => {
            settingController.fetchAdvanceProperties();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            settingController.projectId = event.projectId;
            settingController.fetchAdvanceProperties(event.projectId);
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            contactNumber="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyInvalidFileTypes(errorMessage) {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    contactNumber=""
                />
                &nbsp;&nbsp;{errorMessage}
            </b>,
            {
                position: "top-center",
            }
        );
    }

    refreshData = () => {
        this.state.data = [];
        this.state.index = "";
        this.state.editedAdvancePropertyName = "";
        this.setState(this.state);
        this.fetchAdvanceProperties();
    };

    fetchAdvanceProperties = () => {
        var advancePropertyController = this;
        $.ajax({
            url: "/salesdesk-api/advance-properties",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    advancePropertyController.state.data = res.result;
                    advancePropertyController.state.successResp = true;
                    advancePropertyController.state.editId = "-1";
                    advancePropertyController.setState(advancePropertyController.state);
                } else {
                    advancePropertyController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ": " + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }

    validateFileTypes = (inputValue) => {
        const pattern = /^(\*\.[a-zA-Z0-9]+)(,\s*\*\.[a-zA-Z0-9]+)*$/;
        if (pattern.test(inputValue)) {
            console.log("Input is valid");
            return true;
        } else {
            console.log("Input is invalid");
            return false;
        }
    };

    updateAdvancedSettings = (props, e) => {
        let advancePropertyName = document.getElementById("advancePropertyName" + props.index).innerText.trim();
        let advancePropertyType = props.original.advancePropertyType;
        let advancePropertyValue;

        if (advancePropertyType == "boolean") {
            advancePropertyValue = document.getElementById("advancePropertyValue" + props.index).checked;
        } else {
            advancePropertyValue = document.getElementById("advancePropertyValue" + props.index).innerText.trim();

            if (advancePropertyName == "ALLOWED_UPLOAD_TYPE" && !this.validateFileTypes(advancePropertyValue)) {
                this.notifyInvalidFileTypes(
                    'Invalid input. Please enter extensions in the format "*.extension1, *.extension2, ...".');
                return;
            }
        }

        let description = document.getElementById("description" + props.index).innerText.trim();
        let projectId = localStorage.getItem("currentProjectId");

        var updatedData = {
            id: props.original.id,
            advancePropertyType: advancePropertyType,
            advancePropertyName: advancePropertyName,
            advancePropertyValue: advancePropertyValue,
            description: description,
            projectId: projectId,
        };

        var updatedDataController = this
        $.ajax({
            url: "/salesdesk-api/advance-properties",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(updatedData),
            success: function (res) {
                if (res.success === true) {
                    updatedDataController.state.editId = "-1";
                    updatedDataController.state.index = "";
                    updatedDataController.state.editedAdvancePropertyName = "-1";
                    updatedDataController.notifyUpdate();
                    updatedDataController.fetchAdvanceProperties();
                } else {
                    updatedDataController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        })
    }

    handleCheckBoxChange = (e, props) => {
        console.log("Slider is turned " + e.currentTarget.value + " for " + props.original.advancePropertyName);
        let advancePropertyValue = document.getElementById("advancePropertyValue" + props.index).checked;
        props.original.advancePropertyValue = advancePropertyValue;
        this.setState(this.state);
    };

    makeCelledit(props, e) {
        this.markAsBeingEdited(props.original.advancePropertyName, props.index);
    }

    markAsBeingEdited(advancePropertyName, index = "") {
        this.state.editedAdvancePropertyName = advancePropertyName;
        this.state.index = index;
        this.state.editId = "0";
        var stateObj = this.state;
        this.setState(stateObj);
    }

    notifyUpdate() {
        toast.dismiss();
        this.state.editId = '-1';
        this.setState(this.state);
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Data updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    render() {
        const { data } = this.state
        this.dataColumn = [
            {
                Header: <b>Advance Property Name</b>,
                accessor: "advancePropertyName",
                sortable: false,
                headerStyle: { marginLeft: "10px" },
                Cell: (props) => (
                    <div
                        Align="left"
                        type="text"
                        id={"advancePropertyName" + props.index}
                    >
                        {props.original.advancePropertyName}
                    </div>
                ),
            },
            {
                Header: () => <b>Description</b>,
                accessor: "description",
                sortable: false,
                headerStyle: { marginLeft: "10px" },
                Cell: (props) => (
                    <div
                        Align="left"
                        className="textarea"
                        contentEditable={false}
                        type="text"
                        id={"description" + props.index}
                    >
                        {props.original.description}
                    </div>
                ),
            },
            {
                Header: () => <b>Value</b>,
                accessor: "advancePropertyValue",
                sortable: false,
                headerStyle: { marginLeft: "10px" },
                minWidth: 50,
                Cell: (props) => (
                    <div name="value">
                        {props.original.advancePropertyType == "boolean" ? (
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    id={`advancePropertyValue` + props.index}
                                    disabled={
                                        props.original.advancePropertyName !=
                                        this.state.editedAdvancePropertyName &&
                                        this.state.editId === "-1"
                                    }
                                    checked={
                                        ((props.original.advancePropertyValue) == "false"
                                            || (props.original.advancePropertyValue) == "")
                                            ? "" : "true"}
                                    style={{ width: "22px", height: "22px", marginRight: "3rem" }}
                                    onChange={(e) => {
                                        this.handleCheckBoxChange(e, props);
                                    }}
                                />
                                <span className="slider round"></span>
                            </label>
                        ) : (
                            <div name="value">
                                <div
                                    className="textarea"
                                    style={{
                                        background: "white",
                                        height: "5%",
                                        resize: "none",
                                        borderBottom: "none",
                                        paddingLeft: "2px",
                                        paddingTop: "6px",
                                        border:
                                            props.index == this.state.index || props.index == ""
                                                ? "1px solid #D2D4DC"
                                                : "none",
                                        borderRadius:
                                            props.index == this.state.index || props.index == ""
                                                ? "2px"
                                                : "none",
                                    }}
                                    id={`advancePropertyValue` + props.index}
                                    class="form-control"
                                    rows="1"
                                    contentEditable={
                                        !(props.index == ""
                                            ? false
                                            : props.index != this.state.index)
                                            ? "plaintext-only"
                                            : false
                                    }
                                >
                                    {props.original.advancePropertyValue}
                                </div>
                            </div>
                        )}
                    </div>
                ),
            },
            {
                Header: <b>Action</b>,
                accessor: "action",
                filterable: false,
                flexGrow: 1,
                sortable: false,
                minWidth: 50,
                Cell: (props) => (
                    <div id="action">
                        <button
                            title={
                                props.original.advancePropertyName ==
                                    this.state.editedAdvancePropertyName &&
                                    this.state.editId == "0"
                                    ? "save"
                                    : "edit"
                            }
                            style={{ backgroundColor: "#ffffff", border: "none" }}
                        >
                            <img
                                className="img-responsive"
                                id="editORsave"
                                style={{
                                    height: "2vw",
                                    backgroundColor: "#282a65",
                                    borderRadius: "5px",
                                    padding: "1px",
                                }}
                                src={
                                    props.original.advancePropertyName ==
                                        this.state.editedAdvancePropertyName &&
                                        this.state.editId == "0"
                                        ? this.saveImageSrc
                                        : this.editImageSrc
                                }
                                onClick={(e) => {
                                    props.original.advancePropertyName ==
                                        this.state.editedAdvancePropertyName
                                        ? this.updateAdvancedSettings(props, e)
                                        : this.makeCelledit(props, e);
                                }}
                            />
                        </button>
                    </div>
                ),
            },
        ];

        return (
            <div>
                {/* for reactTable */}
                <link
                    rel="stylesheet"
                    href="assets/css/React_Table_CSS/react-table.css"
                />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link
                    rel="stylesheet"
                    href="assets/css/React_Table_CSS/react-table.css"
                />
                <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
                <div className="container-fluid">
                    <div
                        className="row"
                        style={{ marginRight: "1rem", justifyContent: "end" }}
                    >
                        <div className="col-sm-1">
                            <button
                                className="btn action-button"
                                style={{ marginLeft: "2vw" }}
                                onClick={this.refreshData}
                                title="Refresh"
                            >
                                <img src="./assets/images/refresh_white_24dp.png" />
                            </button>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: "1%" }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                <ReactTable
                                    data={data}
                                    columns={this.dataColumn}
                                    defaultPageSize={5}
                                    pageSizeOptions={[5, 10, 15]}
                                    onPageChange={this.onPageChange}
                                // page={this.state.pageNum}
                                />
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/AdvanceSettings.js